module.exports = __webpack_public_path__ + "img/7.96a01b0d.jpg";